export default [
    { //live
        host: /(frontend-vm|www|dev|relaunch|ostec).(start-bewerbung\.de|wirsindstart\.de)/,
        callback(host, subDomain, domain) {
            return {
                api: `${host}/api`,
                isCommunity: domain === 'wirsindstart.de',
                isApplication: domain === 'start-bewerbung.de',
                subDomain,
                campusEventUrl: "",
                campusOauthBeginUrl: "https://campus.wirsindstart.de/api/openid/redirect/6",
                campusOauthBackendUrl: "https://internal.kiron.ngo/backend/kiron/sso/oauth/redirect/6",
            };
        },
    },
    { //stage
        host: /(rc).(start-bewerbung\.de|wirsindstart\.de)/,
        callback(host, subDomain, domain) {
            return {
                api: `${host}/api`,
                isCommunity: domain === 'wirsindstart.de',
                isApplication: domain === 'start-bewerbung.de',
                subDomain,
                campusOauthBeginUrl: "https://rc-campus.wirsindstart.de/api/openid/redirect/6",
                campusOauthBackendUrl: "https://uat-internal.kiron.ngo/backend/kiron/sso/oauth/redirect/6",
            };
        },
    },
    {
        host: /docker\.wirsindstart\.de/,
        api: 'docker.wirsindstart.de:9002/docker/api',
        isCommunity: true,
        isApplication: false,
        campusOauthBeginUrl: "https://rc-campus.wirsindstart.de/api/openid/redirect/6",
        campusOauthBackendUrl: "https://uat-internal.kiron.ngo/backend/kiron/sso/oauth/redirect/6",
    },
    {
        host: /docker\.start-bewerbung\.de/,
        api: 'docker.start-bewerbung.de:9002/docker/api',
        isCommunity: false,
        isApplication: true,
        campusOauthBeginUrl: "https://rc-campus.wirsindstart.de/api/openid/redirect/6",
        campusOauthBackendUrl: "https://uat-internal.kiron.ngo/backend/kiron/sso/oauth/redirect/6",
    },
];
